import { Option } from "../components/select/Select";
import { UserType } from "./helpers/types";
import { resources } from "./resources";

interface Link {
  icon: string;
  title: string;
  url: string;
  allowedUserTypes: UserType[];
}

const pageSizeStr = localStorage.getItem("KMS_SAVED_PAGE_SIZE");
const pageSize = pageSizeStr ? Number(pageSizeStr) : 10;

export const initialPaginationData = { pageSize, total: 0, pageNumber: 1 };

export const allLinks: Link[] = [
  {
    icon: resources.icons.INSTITUTIONS,
    title: "Issuer Management",
    url: "/issuer-management",
    allowedUserTypes: ["ISW_ADMIN"],
  },
  {
    icon: resources.icons.CERTIFICATE_SOLID,
    title: "Certificate Authority",
    url: "/certificate-authority",
    allowedUserTypes: ["ISW_ADMIN"],
  },
  {
    icon: resources.icons.INSTITUTIONS,
    title: "Des Key Info",
    url: "/des-key-groups",
    allowedUserTypes: ["ISW_ADMIN"],
  },
  {
    icon: resources.icons.CLOUD_UPLOAD,
    title: "Key Migration",
    url: "/key-migration",
    allowedUserTypes: ["ISW_ADMIN"],
  },
  {
    icon: resources.icons.CERTIFICATE_SOLID,
    title: "DES Keys",
    url: "/des-keys",
    allowedUserTypes: ["ISW_ADMIN"],
  },

  {
    icon: resources.icons.INFO_CIRCLE_SOLID,
    title: "RSA Keys",
    url: "/rsa-keys",
    allowedUserTypes: ["ISW_ADMIN"],
  },
];

export const defaultCardSchemeOptions = [
  {
    label: "MasterCard",
    value: "MasterCard",
  },
  {
    label: "Visa",
    value: "Visa",
  },
  {
    label: "Verve",
    value: "Verve",
  },
];

export const imageExtensions: any = {
  tiff: true,
  tif: true,
  bmp: true,
  jpg: true,
  jpeg: true,
  gif: true,
  png: true,
  eps: true,
};

export const allMonths = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
] as const;

export const certificateConfigTypesOptions: Option[] = [
  {
    label: "Certificate (.pfx)",
    value: "certificate(.pfx)",
  },
  {
    label: "Certificate (.pem)",
    value: "certificate(.pem)",
  },
  {
    label: "Private Keystore (.ks)",
    value: "privatekeystore(.ks)",
  },
];
